<script lang="ts">
  import { goto } from '$app/navigation';
  import type { Channel } from '../../../../../firebase/api/channel';
  import type { Feed } from '../../../../../firebase/common/feed';
  import IconButton from '@smui/icon-button';
  import MarkdownEditor, { preprocessBody } from '../../../../../widgets/markdown';

  export let feed: Feed;
  export let channel: Channel;
  export let owner: boolean = false;

  const date = feed.published_at.toLocaleDateString();
  const hours = feed.published_at.getHours().toString().padStart(2, '0');
  const minutes = feed.published_at.getMinutes().toString().padStart(2, '0');
</script>

<div class="feed-cover">
  {#if owner}
    <IconButton
      class="material-symbols-outlined owner-edit"
      on:click={() => {
        goto(`/feeds/${feed.id}`);
      }}
    >
      edit
    </IconButton>
  {/if}
  <img src={feed.thumbnail} alt="{feed.title}のカバー画像" />
</div>
<div class="content">
  <div class="heading">
    <h2>{feed.title}</h2>
    <div class="published-at">
      <time datetime={feed.published_at.toISOString()}>
        {date}
        {hours}時{minutes}分
      </time>
      <div class="creator-name">
        <a href="/c/{channel.display_name}">{channel.name}</a>
      </div>
    </div>
  </div>
  <article>
    {#if typeof feed.body_text === 'string' && feed.body_text.trim() !== ''}
      <div class="body-text">
        <MarkdownEditor content={preprocessBody(feed.body_text, feed.images)} readonly />
      </div>
    {/if}
    <div class="gallery">
      <h3>ギャラリー</h3>
      {#each feed.images as img, index}
        <div class="image-wrapper">
          <a href={img.url} target="_blank" rel="nofollow,noindex">
            <img src={img.url} alt="{feed.title}の画像{index}" loading="lazy" />
          </a>
        </div>
      {/each}
    </div>
  </article>
</div>

<style lang="scss">
  $sp-width: 456px;
  $tb-width: 880px;
  .gallery {
    .image-wrapper {
      aspect-ratio: 33/17;
      // border: solid 1px var(--border-gray);
      // border-radius: 0.5rem;
      background-color: var(--bg-sub);
      padding: 0.5rem 1rem;
      width: 100%;

      &:last-of-type {
        padding-bottom: 1rem;
        border-radius: 0 0 0.5rem 0.5rem;
      }

      &:first-of-type {
        border-radius: 0.5rem 0.5rem 0 0;
        padding-top: 1rem;
      }
    }
    img {
      width: 100%;
      object-fit: contain;
    }
  }

  .heading {
    h2 {
      word-break: break-all;
      margin: 0 0 0.5rem;
      line-height: 1.65;
    }

    .published-at {
      display: flex;
      align-items: center;
      grid-column-gap: 1rem;
      margin-bottom: 1.5rem;
      padding-bottom: 1.5rem;
      border-bottom: 1px solid var(--border-gray);
    }

    time,
    .creator-name {
      font-size: 100%;
      text-align: end;
    }

    time {
      color: var(--text-gray);
    }

    a {
      font-weight: bold;
      text-decoration: none;
    }
  }
  .body-text {
    font-size: 1rem;
    line-height: 1.8;
    letter-spacing: 0.05em;
    white-space: pre-line;
    color: var(--text-gray);
    margin-bottom: 1.5rem;
  }

  .feed-cover {
    position: relative;
    // thumbnail's hidden fixed
    // aspect-ratio: 33/17;
    :global(.owner-edit) {
      position: absolute;
      pointer-events: all;
      right: 1rem;
      top: 1rem;
      background: #ffffffc0;
      border-radius: 9in;
      z-index: 10;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: top;
    }
  }

  .content {
    margin: 2rem 0;
    min-height: inherit;
    position: relative;
    z-index: 1;
    padding: 0 3rem;
  }

  @media screen and (max-width: #{$tb-width}) {
    .gallery {
      .image-wrapper {
        width: calc(100% - 2rem);
        // &:not(:last-of-type) {
        //   margin-bottom: 1.5rem;
        // }
      }
    }

    .heading {
      h2 {
        margin: 0 0 0.3rem;
        font-size: 1.2rem;
      }

      .published-at {
        margin-bottom: 1.3rem;
        padding-bottom: 1.3rem;
      }

      time,
      .creator-name {
        font-size: 0.9rem;
      }
    }
    .body-text {
      font-size: 0.9rem;
      margin-bottom: 1.5rem;
    }

    .content {
      margin: 1rem 0 1.5rem;
      padding: 0 1.2rem;
    }
  }
</style>
